import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "api/interceptors";
import env from "env";

export const api = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: env.REACT_APP_API_HOST,
  }),

  endpoints: () => ({}),
  tagTypes: [
    "Accounts",
    "getNotificationSticky",
    "getTransactionList",
    "getTransactionDetail",
    "getUserProfile",
    "allSavings",
    "LimitTableList",
    "LimitTableScopeDetail",
    "Beneficiaries",
    "TransactionTemplates",
    "nsnnTransactions",
    "NsnnDraft",
    "NsnnAuditTrail",
    "NsnnCheckerInbox",
    "NsnnCatalog",
    "linkedAccountCards",
    "requirementsList",
    "userList",
    // Module Quản lý tiền vay
    "LoanList",
    "LoanDetail",
    "LoanSchedule",
    "LoanPaymentHistory",
    "LoanPaymentOptions",
    "LoanAuditTrail",
    // Module Thư tín dụng (LC.01)
    "LcList",
    "LcCatalogs",
    "LcDetail",
    "LcDocuments",
    "LcPayments",
    // Module Bảo lãnh dự thầu (AW122)
    "GuaranteeDashboard",
    "GuaranteeBeneficiaries",
    "GuaranteeRequestList",
    "GuaranteeRequestDetail",
    "GuaranteeDocuments",
    "GuaranteeAmendmentList",
    "GuaranteeLetterList",
    "GuaranteePendingApproval",
  ],
  keepUnusedDataFor: 60,
  refetchOnMountOrArgChange: true,
});
